import { render, staticRenderFns } from "./EditSpeak.vue?vue&type=template&id=1001d0b5&scoped=true&"
import script from "./EditSpeak.vue?vue&type=script&lang=ts&"
export * from "./EditSpeak.vue?vue&type=script&lang=ts&"
import style0 from "./EditSpeak.vue?vue&type=style&index=0&id=1001d0b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1001d0b5",
  null
  
)

export default component.exports